import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRouter, UnProtectedRouter } from "./container/routes/routes";
import useTokenCheck from "./useTokenCheck";

/// Style
import "./css/style.css";
import { useSelector } from "react-redux";

const SignUp = lazy(() => import("./container/components/auth/Registration"));
const ResetPassword = lazy(
  () => import("./container/components/auth/ResetPassword"),
);
const Login = lazy(() => import("./container/components/auth/Login"));
const VisitPage = lazy(
  () => import("./container/components/LandingPage/VisitPage/Visit"),
);

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  useTokenCheck();

  return (
    <Suspense
      fallback={
        <div id="preloader">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      }
    >
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/home" replace /> : <VisitPage />
          }
        />

        <Route path="/login" element={<Login />} />
        <Route path="/page-register" element={<SignUp />} />
        <Route path="/reset-password/:id/:token" element={<ResetPassword />} />

        <Route
          path="*"
          element={
            <>
              <ProtectedRouter />
              <UnProtectedRouter />
            </>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App;
